import type { ModalEntries } from '@vnetwork/datacentral-shell/host'

// The module's modals, registered with the host by createTendersModule (#216).
// require.context cannot see packages/, so they are declared here, one entry
// per modal, under the key setModal('<Group>/<Modal>/index') has always used.
// check:modal-keys reads this file: keep every entry as
// '<key>': () => import('<relative path>').
export const tendersModals = {
    'TenderPotentialModals/index': () =>
        import('./modals/TenderPotentialModals'),
} satisfies ModalEntries
